import RatingWrapper from '@components/RatingWrapper/RatingWrapper';
import Search from '@components/Search/Search';
import { PagesProvider } from 'context/PagesContext';
import { InferGetServerSidePropsType, NextPage } from 'next';
import getConfig from 'next/config';
import React from 'react';
import getQuerySSR from '../utils/getQuerySSR';
import { NextPageContext } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';

const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps(params: NextPageContext) {
  const page = getQuerySSR(params.query?.page);
  const pageParam = page ? `page=${page}` : '';
  const region = getQuerySSR(params.query?.region);
  const regionParam = region ? `region=${region}` : '';
  const city = getQuerySSR(params.query?.city);
  const cityParam = city ? `city=${city}` : '';
  const name = getQuerySSR(params.query?.name);
  const nameParam = name ? `name=${name}` : '';
  const queryArray = [pageParam, regionParam, cityParam, nameParam]
    .filter((i) => i !== '')
    .join('&')
    .trim();

  const res = await fetch(`${publicRuntimeConfig.INTERNAL_API_URL}/pages?${queryArray}`);
  const resp = await res.json();
  return {
    props: {
      resp,
      page: page || 1,
    },
  };
}

const Home: NextPage = ({
  resp,
  page,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const router = useRouter();
  const canonicalUrl =
    Object.keys(router.query).length === 0
      ? `${publicRuntimeConfig.BASE_URL}${router.asPath}`
      : `${publicRuntimeConfig.BASE_URL}${router.asPath.substring(1)}`;

  return (
    <>
      <Head>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <PagesProvider value={{ ...(typeof resp === 'object' ? resp : {}), page: +page }}>
        <Search />
        <RatingWrapper />
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WZQBQ5P"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
          }}
        />
      </PagesProvider>
    </>
  );
};

export default Home;
